@if (authService.isRedirecting()) {
  <loading-indicator />
} @else if (authService.showAuthErrorPage()) {
  <router-outlet></router-outlet>
} @else {
  <app-navigation>
    <router-outlet></router-outlet>
  </app-navigation>
}
